import { Image } from '@finn/ui-components';
import { cn, getCloudinaryImgUrl, parseToHtml } from '@finn/ui-utils';
import Link from 'next/link';
import React from 'react';

import { MediaData } from '~/types/cosmicModules';

type Props = {
  title: string;
  subtitle: string;
  photo: { sm: MediaData; md: MediaData; lg: MediaData };
  href: string;
  href_content: string;
  backgroundColor: string;
  isSelected?: boolean;
  isTouched?: boolean;
  onEvent?: (event: React.SyntheticEvent) => void;
};

const CategoryCard: React.FunctionComponent<Props> = ({
  photo,
  title,
  subtitle,
  href,
  href_content,
  backgroundColor,
  isSelected = false,
  isTouched = false,
  onEvent,
}) => {
  const sendEvent = (event: React.SyntheticEvent) => {
    if (onEvent) {
      onEvent(event);
    }
  };

  return (
    <Link
      href={href}
      className={cn(
        'mb-9 flex h-[271px] flex-col justify-between bg-cotton sm:min-w-[49%] md:mr-6 md:h-[345px] md:min-w-[auto] md:flex-1 md:bg-white md:last:mr-0',
        {
          'text-white': isSelected || isTouched,
          'bg-trustedBlue text-white':
            (isSelected || isTouched) && !backgroundColor,
        }
      )}
      style={{ backgroundColor }}
      onTouchStart={sendEvent}
      onTouchEnd={sendEvent}
      onTouchCancel={sendEvent}
      onMouseEnter={sendEvent}
      onMouseLeave={sendEvent}
    >
      <div>
        <p className="text-center mobile-t4-semibold md:mt-12 md:web-t4-semibold">
          {parseToHtml(title)}
        </p>
        <p className="mt-3 body-12-light">{parseToHtml(subtitle)}</p>
        {(isSelected || isTouched) && (
          <div className="hidden md:block">
            <span
              className={cn(
                'mx-auto mb-0 mt-5 block w-[134px] rounded-sm border border-solid px-5 py-2 body-12-regular'
              )}
            >
              {href_content}
            </span>
          </div>
        )}
      </div>
      <Image
        variant="responsive"
        lgImage={getCloudinaryImgUrl(photo?.lg?.url ?? '', {
          w: 452,
          dpr: 2,
        })}
        mdImage={getCloudinaryImgUrl(photo?.md?.url ?? '', {
          w: 324,
          dpr: 2,
        })}
        smImage={getCloudinaryImgUrl(photo?.sm?.url ?? '', {
          w: 260,
          dpr: 2,
        })}
        className="mx-auto my-0 max-w-[80%] md:mb-8"
      />
    </Link>
  );
};

export default CategoryCard;
